export default __webpack_public_path__ + "913042bcd5a5422bb1d2d479e62d6a83.png";